// Lightweight analytics event helper.
// Forwards events to Google Analytics (gtag) or GTM dataLayer when present,
// so events start flowing automatically once analytics is installed.
export function trackEvent(name, params = {}) {
  try {
    if (typeof window === 'undefined') return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: name, ...params });
    }
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.debug('[track]', name, params);
    }
  } catch (e) {
    // analytics must never break the page
  }
}
